<template>
    <b-container>
        <div :class="heading">Dropdown-Name:</div>
        <b-input-group>
            <b-form-input v-model="dropdown.name"></b-form-input>
            <b-input-group-append>
                <b-button variant="outline-success" @click="updateDropdownName(dropdown)">Speichern</b-button>
            </b-input-group-append>
        </b-input-group>
        <hr class="mt-4 mb-4">
        <div :class="heading">Seiten:</div>
        <b-list-group>
            <draggable v-model="sites" handle=".handle" @change="savePositions()">
                <b-list-group-item
                    v-for="site in sites" :key="site.position"
                >
                    <b-row>
                        <b-col><router-link :to="{ path: `/${site.id}/Sektionen` }">{{ site.name }}</router-link></b-col>
                        <b-col cols="1">
                            <b-icon-trash @click="confirmDeleteSite(site.id)"></b-icon-trash>
                        </b-col>
                        <b-col cols="1">
                            <b-icon-list class="handle"></b-icon-list>
                        </b-col>
                    </b-row>
                </b-list-group-item>
            </draggable>
        </b-list-group>
        <hr class="mt-4 mb-4">
        <h4>Neuer Seiten-Name:</h4>
        <b-input-group class="mb-4">
            <b-form-input v-model="siteName"></b-form-input>
            <b-input-group-append>
                <b-button variant="outline-success" @click="createSite({siteName, dropdown})">Erstellen</b-button>
            </b-input-group-append>
        </b-input-group>
    </b-container>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import helpers from "@/helpers";
import draggable from "vuedraggable";

export default {
    name: "SiteList",
    components: {
        draggable,
    },
    data() {
        return {
            dropdownId: parseInt(this.$route.params.dropdownId),
            siteName: "",
            heading: "h4"
        }
    },
    mounted() {
        this.getSitesForDropdown(this.dropdownId)
        this.getDropdownById(this.dropdownId)
    },
    methods: {
        ...mapActions([
            'getSitesForDropdown',
            'getDropdownById',
            'updateDropdownName',
            'createSite',
            'deleteDropdown',
            'saveSitePositions',
            'deleteSite',
        ]),
        ...mapMutations([
            'clearSites',
            'storeSites'
        ]),
        savePositions() {
            const sites = this.sites.map((nav, index) => nav = {id: nav.id, position: index})
            try {
                this.saveSitePositions({sites, dropdownId: this.dropdownId})
                helpers.handleSuccessMessage("Die Reihenfolge wurde gespeichert!")
            } catch (e) {
                helpers.handleWarningMessage("Die Reihenfolge konnte nicht gespeichert werden!")
            }
        },
        confirmDeleteSite(siteId) {
            this.$bvModal.msgBoxConfirm('Wollen Sie die Seite wirklich löschen ?', {
                title: 'Löschen',
                okVariant: 'outline-danger',
                okTitle: 'Ja',
                cancelTitle: 'Abbrechen',
                cancelVariant: 'outline-success',
                centered: true
            })
                .then(value => {
                    if (value) {
                        this.deleteSite(siteId)
                    }
                })
        },
    },
    computed: {
        ...mapGetters([
            'getStoredSites',
            'getStoredDropdown'
        ]),
        sites: {
            get() {
                return this.getStoredSites
            },
            set(sites) {
                this.storeSites(sites)
            }
        },
        dropdown() {
            return this.getStoredDropdown
        }
    },
    beforeDestroy() {
        this.clearSites()
    }
}
</script>

<style scoped>

</style>
